import { render, staticRenderFns } from "./mobile2.vue?vue&type=template&id=85486abc&scoped=true&"
import script from "./mobile2.vue?vue&type=script&lang=js&"
export * from "./mobile2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85486abc",
  null
  
)

export default component.exports